export enum LogicOperatorType {
    and = 0,
    or = 1
}
